import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/meuBanner.png";
import 'animate.css';    
import TrackVisibility from 'react-on-screen'; 
  
export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);  
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ "Web Developer"];
  const period = 2000; 

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
             <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
             <span className="tagline">Bem vindo ao meu portifólio</span>  
             <h1>{`Eae, eu sou Alan`} <span className="txt-rotate" dataPeriod="1000" data-rotate='[ "Desenvolvedor Web", "Front End" ]'><span className="wrap">{text}</span></span></h1>
               <p>Desenvolvedor Front-end Especialista em React, VTEX IO, JavaScript, TypeScript, Vite, Tailwind, Html, Css, Angular. Sou um entusiasta da tecnologia e desenvolvedor front-end apaixonado por criar experiências digitais excepcionais. Minhas habilidades abrangentes em React, VTEX IO, JavaScript e TypeScript têm sido fundamentais para o sucesso de diversos projetos nos quais participei.</p>             
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "meuBanner.png" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
